import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "14",
      cy: "14",
      r: "13.3",
      fill: "#fff",
      stroke: "#1C1C1C",
      "stroke-width": "1.4"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M24.11 14a10.112 10.112 0 0 1-12.975 9.697L14 14h10.11Z"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "14",
      cy: "14",
      r: "9.411",
      stroke: "#1C1C1C",
      "stroke-width": "1.4"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#1C1C1C",
      d: "M11.58 17.89a.62.62 0 0 0 .614-.628.62.62 0 0 0-.615-.627.62.62 0 0 0-.614.627.62.62 0 0 0 .614.627ZM13.177 17.89a.62.62 0 0 0 .614-.628.62.62 0 0 0-.614-.627.62.62 0 0 0-.614.627.62.62 0 0 0 .614.627ZM14.778 17.89a.62.62 0 0 0 .614-.628.62.62 0 0 0-.614-.627.62.62 0 0 0-.615.627.62.62 0 0 0 .615.627ZM13.177 16.259a.62.62 0 0 0 .614-.627.62.62 0 0 0-.614-.627.62.62 0 0 0-.614.627.62.62 0 0 0 .614.627ZM14.778 16.259a.62.62 0 0 0 .614-.627.62.62 0 0 0-.614-.627.62.62 0 0 0-.615.627.62.62 0 0 0 .615.627ZM16.376 16.259a.62.62 0 0 0 .614-.627.62.62 0 0 0-.614-.627.62.62 0 0 0-.615.627.62.62 0 0 0 .615.627ZM14.778 14.626a.62.62 0 0 0 .614-.627.62.62 0 0 0-.614-.627.62.62 0 0 0-.615.627.62.62 0 0 0 .615.627ZM16.376 14.626A.62.62 0 0 0 16.99 14a.62.62 0 0 0-.614-.627.62.62 0 0 0-.615.627.62.62 0 0 0 .615.627ZM17.976 14.626A.62.62 0 0 0 18.59 14a.62.62 0 0 0-.614-.627.62.62 0 0 0-.615.627.62.62 0 0 0 .615.627ZM13.177 12.996a.62.62 0 0 0 .614-.627.62.62 0 0 0-.614-.627.62.62 0 0 0-.614.627.62.62 0 0 0 .614.627ZM14.778 12.996a.62.62 0 0 0 .614-.627.62.62 0 0 0-.614-.627.62.62 0 0 0-.615.627.62.62 0 0 0 .615.627ZM16.376 12.996a.62.62 0 0 0 .614-.627.62.62 0 0 0-.614-.627.62.62 0 0 0-.615.627.62.62 0 0 0 .615.627ZM11.58 11.365a.62.62 0 0 0 .614-.627.62.62 0 0 0-.615-.627.62.62 0 0 0-.614.627.62.62 0 0 0 .614.627ZM13.177 11.365a.62.62 0 0 0 .614-.627.62.62 0 0 0-.614-.627.62.62 0 0 0-.614.627.62.62 0 0 0 .614.627ZM14.778 11.365a.62.62 0 0 0 .614-.627.62.62 0 0 0-.614-.627.62.62 0 0 0-.615.627.62.62 0 0 0 .615.627Z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "stamp"}) } }